import React from "react";
import { teamMembers } from "../mock";
import ContactForm from "../components/heider/ContactForm";
import Footer from "../components/heider/Footer";
import useReveal from "../hooks/useReveal";
import { Star, ArrowRight, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const AgentCard = ({ m }) => (
  <div className="reveal-scale group text-center">
    <Link to={`/team/${m.slug}`} className="block relative mx-auto w-full aspect-square rounded-full overflow-hidden bg-neutral-200 ring-1 ring-black/[0.06] shadow-[0_18px_40px_rgba(0,0,0,0.10)]">
      <img src={m.image} alt={m.name} loading="lazy" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 rounded-full bg-black/45 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
        <span className="text-white text-[10px] tracking-luxe uppercase border border-white/70 px-4 py-2">View Profile</span>
      </div>
    </Link>
    <div className="pt-5">
      <Link to={`/team/${m.slug}`}><h3 className="font-serif-display text-2xl text-[#1a1a1a] hover:text-[#b4936a] transition-colors">{m.name}</h3></Link>
      <p className="text-[10px] tracking-luxe uppercase text-neutral-500 mt-1 mb-3">{m.role}</p>
      <div className="flex items-center justify-center gap-2 mb-4">
        {m.rating ? (
          <>
            <span className="flex items-center gap-1 text-[#b4936a]"><Star size={14} fill="#b4936a" /> <span className="text-[13px] text-[#1a1a1a] font-medium">{m.rating}</span></span>
            <span className="text-[12px] text-neutral-400">({m.reviews} reviews)</span>
          </>
        ) : (
          <span className="text-[12px] text-neutral-400">No reviews yet</span>
        )}
      </div>
      {(m.phone || m.email) && (
        <div className="border-t border-neutral-200 pt-3 space-y-1.5 flex flex-col items-center">
          {m.phone && <a href={`tel:${m.phone}`} className="flex items-center gap-2 text-[12px] text-neutral-600 hover:text-[#b4936a] transition-colors"><Phone size={13} className="text-[#b4936a]" /> {m.phone}</a>}
          {m.email && <a href={`mailto:${m.email}`} className="flex items-center gap-2 text-[12px] text-neutral-600 hover:text-[#b4936a] transition-colors break-all"><Mail size={13} className="text-[#b4936a]" /> {m.email}</a>}
        </div>
      )}
    </div>
  </div>
);

const TeamPage = () => {
  useReveal();
  return (
    <div className="page-in">
      {/* Intro — A Team Built to Win */}
      <section className="bg-[#0d0d0d] text-white pt-40 pb-20 md:pt-48 md:pb-24">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10 text-center">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">The Advisors</p>
          <h1 className="font-serif-display text-5xl md:text-7xl lg:text-8xl font-light" data-testid="team-title">A Team Built to Win</h1>
          <p className="text-white/60 text-[15px] leading-relaxed max-w-2xl mx-auto mt-6">When you hire one of us, you get all of us &mdash; a full bench of specialists covering every corner of the DMV.</p>
        </div>
      </section>

      {/* Agents */}
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-16 reveal">
            <div className="overflow-hidden group">
              <img src="/team/group-2.webp" alt="The Capital Corner Group team" loading="lazy" className="w-full h-[280px] md:h-[440px] object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
            </div>
            <div className="overflow-hidden group">
              <img src="/team/group-1.webp" alt="The Capital Corner Group team" loading="lazy" className="w-full h-[280px] md:h-[440px] object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
            </div>
          </div>
          <div className="flex gap-5 md:gap-6 overflow-x-auto snap-x snap-mandatory pb-6 pr-6 cc-scroll" data-testid="team-agents-row">
            {teamMembers.map((m) => (
              <div key={m.name} data-testid={`team-card-${m.slug}`} className="snap-start shrink-0 w-[220px] md:w-[240px]"><AgentCard m={m} /></div>
            ))}
          </div>
          <p className="text-center text-neutral-400 text-[11px] tracking-luxe uppercase mt-2">Swipe to meet the team &rarr;</p>
          <div className="text-center mt-16 reveal flex flex-wrap justify-center gap-4">
            <Link to="/join" data-testid="team-join-btn" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-white bg-[#0d0d0d] px-8 py-4 hover:bg-[#b4936a] transition-colors">
              Become an Agent <ArrowRight size={14} />
            </Link>
            <Link to="/partners" data-testid="team-partners-btn" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] border border-[#1a1a1a] px-8 py-4 hover:bg-[#1a1a1a] hover:text-white transition-colors">
              Our Trusted Partners <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>

      <ContactForm />
      <Footer />
    </div>
  );
};

export default TeamPage;
